export default {
    data() {
        return {
            windowWidth: null,
        }
    },

    methods: {
        windowResize() {
            this.setWindowWidth()
        },

        setWindowWidth() {
            this.windowWidth = window.innerWidth
        },
    },

    computed: {
        isSmartphone() {
            return this.windowWidth <= 400
        },

        isSmartPhoneExtraSmall() {
            return this.windowWidth <= 340
        },

        isSmartphoneLarge() {
            return this.windowWidth <= 600
        },

        isTabletSmall() {
            return this.windowWidth <= 820
        },

        isTablet() {
            return this.windowWidth <= 1024
        },

        isLaptop() {
            return this.windowWidth <= 1440
        },
    },

    created() {
        this.setWindowWidth()
        window.addEventListener('resize', this.windowResize)
    },

    destroyed() {
        window.removeEventListener('resize', this.windowResize)
    },
}
